<div class="information-card-details">
  @if (compData?.container?.title) {
    <div class="info-title">
      {{ compData?.container?.title | titlecase }}
    </div>
  }
  @if (compData?.container?.description) {
    <div class="msh">
      {{ compData?.container?.description | toParagraph }}
    </div>
  }

  @switch (compData?.container?.type) {
    @case ('card') {
      <ng-container *ngTemplateOutlet="cardTemplate;"></ng-container>
    }
    @case ('list') {
      <ng-container *ngTemplateOutlet="listTemplate"></ng-container>
    }
    @case ('table') {
      <ng-container *ngTemplateOutlet="tableTemplate"></ng-container>
    }
    @case ('faqs') {
      <ng-container *ngTemplateOutlet="faqTemplate"></ng-container>
    }
    @case ('itinerary') {
      <ng-container *ngTemplateOutlet="itineryTemplate"></ng-container>
    }
    @case ('pointer') {
      <ng-container *ngTemplateOutlet="pointerTemplate"></ng-container>
    }
  }
</div>

<ng-template #itineryTemplate>
  <div class="itinery-template">
    @if (compData?.container?.containers) {
      @for (container of compData?.container?.containers; track container) {
        <div class="{{ container?.type }}-view card-container">
          <ul class="accordion-menu">
            <li>
              <input type="checkbox" id="{{ container?.order }}"/>
              @if (container?.title) {
                <label for="{{ container?.order }}"
                       class="iti-head">
                  <div class="flex-container ion-align-items-center ion-justify-content-between">
                    <div class="flex-container ion-align-items-center hd-bx">
                      <div class="badge">DAY {{ container?.order }}</div>
                      <div class="title">{{ container?.title | titlecase }}</div>
                    </div>
                    <div>
                      <div class="arrow"></div>
                    </div>
                  </div>
                </label>
              }
              <section>
                @if (container?.description) {
                  <div class="desc"
                       [innerHTML]="container?.description  | safe: 'html'"></div>
                }
                @if (container?.subTitle) {
                  <div class="desc">{{ container?.subTitle | toParagraph }}</div>
                }
              </section>
            </li>
          </ul>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #cardTemplate>
  <div class="card-template">
    @if (compData?.container?.containers) {
      @for (container of compData?.container?.containers; track container) {
        <div class="{{ container?.type }}-view card-container">
          <div class="card">
            @if (container?.image?.path) {
              <div class="card-img">
                <!-- Image -->
                <div class="container-img">
                  <img [ngSrc]="container?.image?.path" [alt]="container?.image?.alt" width="100" height="100"
                       loading="lazy">
                </div>
              </div>
            }
            <div class="card-details">
              @if (container?.title) {
                <div class="title">{{ container?.title | titlecase }}</div>
              }
              @if (container?.description) {
                <div class="desc">{{ container?.description | toParagraph }}</div>
              }
              <div class="pointer-detail">
                @if (container?.descriptions?.length > 0) {
                  @for (desc of container?.descriptions; track desc) {
                    <div class="desc">
                      <span><span class="dot"></span></span>
                      <!--                      <div [innerHTML]="desc | safe: 'html'"></div>-->
                      {{ desc | toParagraph }}
                    </div>
                  }
                }
              </div>
            </div>
          </div>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #faqTemplate>
  <div class="faqs-template">
    @if (compData?.container?.containers) {
      <div itemscope itemtype="https://schema.org/FAQPage" class="faq-card">
        @for (container of compData?.container?.containers; track container) {
          <div itemscope itemprop="mainEntity"
               itemtype="https://schema.org/Question" class="faq-data">
            <div class="{{ container?.type }}-view card-container">
              @if (container?.title && container?.description) {
                <div class="faq-box">
                  <div class="title" itemprop="name">
                    {{ container?.title | titlecase }}
                  </div>
                  <div class="desc" itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <div itemprop="text" [innerHTML]="container?.description | toParagraph"></div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #listTemplate>
  <div class="list-template">
    @if (compData?.container?.containers) {
      @for (container of compData?.container?.containers; track container) {
        <div class="{{ container?.type }}-view card-box"
             [ngClass]="{ 'card-container': !compData?.container?.hideBackground }">
          <div class="card">
            <div class="card-details">
              <div class="htm-desc" [ngClass]="{ 'read-less': !readMore, 'read-more': readMore }"
                   [style.line-clamp]="clampRow"
                   [style.-webkit-line-clamp]="clampRow">
                @if (container?.title) {
                  <div class="title">{{ container?.title | titlecase }}</div>
                }
                @if (container?.description) {
                  <div class="desc">{{ container?.description | toParagraph }}</div>
                }
                @if (container?.htmlDescription) {
                  <div [innerHTML]="container?.htmlDescription | safe : 'html'" class="htmlDesc"></div>
                }
              </div>
              @if (container?.htmlDescription) {
                <div class="htm-desc">
                  @if (clampRow > 0) {
                    <div class="see-more-btn flex-container ion-align-items-center ion-justify-content-end"
                         (click)="readMore = !readMore">
                      @if (readMore) {
                        <div class="btn">Read Less</div>
                      }
                      @if (!readMore) {
                        <div class="btn">Read More...</div>
                      }
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #tableTemplate>
  @if (compData?.container?.containers) {
    <div class="table-img-template">
      @for (container of compData?.container?.containers | filterArrayPipe: 'type': 'grid_image'; track container) {
        <div class="{{ container?.type }}_view card-container">
          <div class="card">
            <div class="card-details">
              @if (container?.title) {
                <div class="title">
                  {{ container?.title | titlecase }}
                </div>
              }
              @if (container?.description) {
                <div class="desc">
                  {{ container?.description | toParagraph }}
                </div>
              }
              <div class="rules-img">
                <div class="img">
                  <img [ngSrc]="container?.image?.path" alt="rules" width="100" height="100" loading="lazy">
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="table-template image-card">
      @for (container of compData?.container?.containers | filterArrayPipe: 'type': 'grid'; track container) {
        <div class="{{ container?.type }}-view card-container">
          <div class="card">
            <div class="card-details">
              @if (container?.title) {
                <span class="title">
                    {{ container?.title | titlecase }}
                  </span>
              }
              @if (container?.description) {
                <span class="desc">
                    {{ container?.description | toParagraph }}
                  </span>
              }
            </div>
          </div>
        </div>
      }
    </div>
  }
</ng-template>

<ng-template #pointerTemplate>
  @if (compData?.container?.containers) {
    <div class="pointer-template"
         [ngStyle]="{ 'background': compData?.container?.background , 'border': compData?.container?.border }">
      @for (container of compData?.container?.containers; track container; let index = $index; ) {
        <div class="{{ container?.type }}-view card-container flex-container ion-align-items-start">
          @if (container?.description) {
            <span>
              {{ index + 1 + '. ' }}
            </span>
            <span class="desc">{{ container?.description | toParagraph }}</span>
          }
        </div>
      }
    </div>
  }
</ng-template>
